import createTheme from './theme';
var defaultTheme = createTheme();
export default defaultTheme;
//# sourceMappingURL=defaultTheme.js.map